import { Directive, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';
@Directive({
    selector: '[validatorLength][ngModel]',
    providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidatorMaxlengthDirective), multi: true }]
})
export class ValidatorMaxlengthDirective {
    ///这是判断需要什么类型的校验
    @Input('validatorLength')
    type: any;

    constructor() { }

    validate(control: AbstractControl): { [property: string]: string } {

        let value = control.value;  //  取得输入框的值
        if (value === null || value === "" || value === undefined) {  //  为空时不验证
            return null
        }
        if (value.length <= this.type) {
            return null;
        }
        return {
            validatorLength: `最大长度为${this.type}`
        };
    }
}
